import { useEffect, useState } from "react";
import ProjectItem from "./ProjectItem";
import { getSavedDesign } from "../../../../api/save-design.api";
import Cookies from "js-cookie";
import { checkAndCreateSessionIdFromCookie } from "../../../../../utils/utils";
import { useAppSelector } from "../../../../../hooks/reduxHooks";
import AuthModal from "./AuthModal";

// Add proper type definition for shownProjects
interface Project {
  id: number;
  title: string;
  image?: string;
  editedTime?: string;
}

const Account = () => {
  const [shownProjects, setShownProjects] = useState<Project[]>([]);
  const [sortType, setSortType] = useState("edited");
  const [savedDesigns, setSavedDesigns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [authModalMode, setAuthModalMode] = useState<'login' | 'signup'>('login');
  
  // Get auth token from Redux state
  const token = useAppSelector((state) => state.auth.token);
  const isLoggedIn = !!token;

  // Get userId from cookie or token
  const getUserId = () => {
    return Cookies.get("userId") || localStorage.getItem("userId");
  };

  useEffect(() => {
    // Initialize session
    checkAndCreateSessionIdFromCookie();
    
    // Get projects
    getProjects();
  }, [token]); // Re-fetch when token changes (login/logout)

  const getProjects = async () => {
    setIsLoading(true);
    const userId = getUserId();
    
    if (userId) {
      try {
        const designs = await getSavedDesign(userId);
        setSavedDesigns(designs === "User not found" ? [] : designs);
      } catch (error) {
        console.error("Error fetching designs:", error);
      }
    }
    
    setIsLoading(false);
  };

  const handleSort = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSortType(e.target.value);
    
    let newProjectsArray;
    if (e.target.value === "az") {
      // Now TypeScript knows that a and b have title properties
      newProjectsArray = [...shownProjects].sort((a, b) =>
        a.title > b.title ? 1 : -1
      );
    } else if (e.target.value === "za") {
      newProjectsArray = [...shownProjects].sort((a, b) =>
        a.title < b.title ? 1 : -1
      );
    } else if (e.target.value === "edited") {
      newProjectsArray = [...shownProjects].sort((a, b) =>
        a.id > b.id ? 1 : -1
      );
    } else {
      newProjectsArray = shownProjects;
    }
    setShownProjects(newProjectsArray);
  };

  const openAuthModal = (mode: 'login' | 'signup') => {        
    if (mode === 'login') {
      setAuthModalMode('login');
      setIsAuthModalOpen(true);
    } else {
      setAuthModalMode('signup');
      setIsAuthModalOpen(true);
    }
  };

  return (
    <div>
      <div className="font-bold text-2xl tracking-wide">My Projects</div>
      <div className="text-[#8D9095] border-b border-solid border-lightgrey pb-3 mb-3">
        Manage all of your existing designs
      </div>

      {/* <div className="flex justify-between items-center border-b border-solid border-lightgrey pb-3 mb-3">
        <div>
          <strong>
            {savedDesigns.length} project{savedDesigns.length === 1 ? "" : "s"}
          </strong>
          <button className="text-sm ml-4">See all</button>
        </div>
        <div>
          <select
            name="projectSorting"
            id="projectSorting"
            className="border border-solid border-lightgrey p-2 rounded-full cursor-pointer text-sm"
            onChange={handleSort}
            value={sortType}
          >
            <option value="edited">Last edited</option>
            <option value="az">A - Z</option>
            <option value="za">Z - A</option>
          </select>
        </div>
      </div>

      <div className="my-6">
        <div className="flex gap-3 py-2 px-3 border border-solid border-lightgrey rounded-full mb-4">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.64005 18.4798C14.5223 18.4798 18.48 14.522 18.48 9.6398C18.48 4.75761 14.5223 0.799805 9.64005 0.799805C4.75785 0.799805 0.800049 4.75761 0.800049 9.6398C0.800049 14.522 4.75785 18.4798 9.64005 18.4798Z"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.2027 21.2L16.2727 16.27"
              stroke="black"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <input
            className="w-full outline-none"
            type="text"
            placeholder="Search for your projects..."
          />
        </div>
        
        {isLoading ? (
          <div className="py-4 text-center">Loading designs...</div>
        ) : savedDesigns && savedDesigns.length > 0 ? (
          savedDesigns.map((item: any, index: number) => (
            <ProjectItem key={item.id || index} project={item} refresh={getProjects} />
          ))
        ) : (
          <div className="py-4 text-center">
            {isLoggedIn 
              ? "No designs found. Create a design and save it to see it here." 
              : "Log in to view your saved designs."}
          </div>
        )}
      </div> */}

      {/* <div className="text-[#8D9095] border-b border-solid border-lightgrey pb-3 mb-3">
        Not seeing all your designs? Try logging in or creating an account (this email and password is separate from your other Account)
      </div>
      
      <div className="flex gap-3">
        <button
          onClick={() => openAuthModal('signup')}
          className="lg:my-4 lg:rounded-full max-lg:h-full bg-primaryred text-center text-white py-3 px-5 tracking-wider w-[100%] cursor-pointer"
        >
          <div className="uppercase font-bold text-xl">Sign Up</div>
        </button>        
        <button
          onClick={() => openAuthModal('login')}
          className="lg:my-4 lg:rounded-full max-lg:h-full text-center text-primaryred border border-solid border-primaryred py-3 px-5 tracking-wider w-[100%] cursor-pointer"
        >
          <div className="uppercase font-bold text-xl">Login</div>
        </button>
      </div>
      
      {/* Auth Modal
      <AuthModal 
        isOpen={isAuthModalOpen} 
        onClose={() => {
          setIsAuthModalOpen(false);
          // Refresh projects after modal closes in case they logged in
          getProjects();
        }} 
        initialMode={authModalMode}
      /> */}
    </div>
  );
};

export default Account;
